var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-inline--fa fa-arrow-up fa-w-14 fa-3x",
    "aria-hidden": "true",
    "data-icon": "arrow-up",
    "data-prefix": "fas",
    focusable: "false",
    role: "img",
    viewBox: "0 0 448 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m34.9 222.45-22.2 22.2c-9.4 9.4-9.4 24.6 0 33.9l194.3 194.4c9.4 9.4 24.6 9.4 33.9 0l194.3-194.3c9.4-9.4 9.4-24.6 0-33.9l-22.2-22.2c-9.5-9.5-25-9.3-34.3 0.4l-114.7 120.4v-287.4c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v287.4l-114.8-120.5c-9.3-9.8-24.8-10-34.3-0.4z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.0325cb7842334c26fd8080e8cdd7c218.svg";
export { ForwardRef as ReactComponent };